export default [
  {
    title: 'PZS Wizard',
    icon: 'HomeIcon',
    route: 'app-pzs',
    action: 'read',
    resource: 'pzs',
  },
  {
    title: 'WAM Wizard',
    icon: 'HomeIcon',
    route: 'app-wam',
    action: 'read',
    resource: 'wam',
  },
  {
    title: 'RO Wizard',
    icon: 'HomeIcon',
    route: 'app-ro',
    action: 'read',
    resource: 'ro',
  },
]
